export const eeReport = 'EEReport/';
export const eeaReport = 'EmploymentEquity/EEAReport/';

export const GenerateReport = eeReport + 'GenerateEEAReport';
export const GenerateEEAReport = eeaReport + 'GenerateEEAReport';

export const SearchReport = eeReport + 'Search';
export const deleteReport = eeReport + 'DeleteReport';
export const downloadReport = eeReport + 'DownloadReport';

export const Report = 'Report/';
export const GetLatestPublishedReport = Report + 'GetLatestPublishedReport/';
export const GetDocumentUrl = Report + 'GetDocumentUrl/';